const CATEGORY_THEMES: Record<string, string> = {
  health: 'vibrant fitness and wellness, energetic movement, nature and vitality',
  career: 'modern professional success, ambition, technology and growth',
  mind: 'mindfulness, curiosity, calm focus, soft contemplative light',
  finance: 'financial freedom, abundance, prosperity, golden tones',
  relationships: 'human connection, warmth, community, togetherness',
  creative: 'artistic expression, colorful creativity, imagination and craft',
}

// Flux paints anything that looks like copy (quoted phrases, figures, currency)
// onto the image, and ignores negative instructions, so strip it from the input
// and describe a wordless scene in positive terms instead.
const STYLE =
  'Cinematic, warm dramatic lighting, painterly fine-art style, high detail. Purely visual wordless imagery, blank unmarked surfaces, no signage, no captions.'

export function stripText(s: string): string {
  return s
    .replace(/["“”'‘’`«»「」『』]/g, ' ')
    .replace(/[$€£¥₹%#@]/g, ' ')
    .replace(/\d[\d,.:/]*\s*(k|m|bn|kg|km|lbs?|mi|x)?\b/gi, ' ')
    .replace(/\b(text|words?|letters?|typography|title|caption|sign|label|poster|banner)\b/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function themeFor(category: string): string {
  return CATEGORY_THEMES[category?.toLowerCase() ?? ''] ?? 'achievement and progress'
}

export function composePrompt(scene: string, category: string): string {
  const theme = themeFor(category)
  const cleaned = stripText(scene.replace(STYLE, '').replace(`${theme}.`, '')).replace(
    /[\s.]+$/,
    '',
  )
  return `${cleaned ? `${cleaned}. ` : ''}${theme}. ${STYLE}`
}

/** Offline fallback when no scene could be generated: the goal's gist, minus anything text-like. */
export function defaultPrompt(title: string, category: string): string {
  const gist = stripText(title)
  return composePrompt(gist ? `A scene evoking ${gist.toLowerCase()}` : '', category)
}

export function sceneRequest(title: string, category: string): string {
  return `Describe one concrete, photographable scene that visually represents achieving this personal goal. Goal: ${title}
Category: ${category || 'general'}

Rules:
- One sentence, max 30 words, in English.
- Only objects, people, places, light and mood.
- Never mention numbers, money amounts, dates, names, brands, words, text, signs, screens, documents, papers, books, packaging, labels, maps, charts or the goal title itself.
- Output the sentence only.`
}
